module.exports = __webpack_public_path__ + "static/media/random-shapes.51883585.svg";